import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();
  const items = [
    { key: 'trust.item1', icon: 'ri-checkbox-circle-line' },
    { key: 'trust.item2', icon: 'ri-guide-line' },
    { key: 'trust.item3', icon: 'ri-table-line' },
    { key: 'trust.item4', icon: 'ri-scan-line' },
    { key: 'trust.item5', icon: 'ri-ship-line' },
  ];

  return (
    <section className="w-full bg-background-50 py-4 border-b border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {items.map((item) => (
            <div key={item.key} className="flex items-center gap-1.5 text-foreground-700">
              <i className={`${item.icon} text-accent-500 text-sm`}></i>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{t(item.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}